import { useTranslation } from 'react-i18next';

// From the utils file, not the barrel: the barrel also loads the picker component.
import { getSelectionLabel } from 'components/shared/PlanningEntityPicker/PlanningEntityPicker.utils';

import type { PlanningEntitySelection } from 'components/shared/PlanningEntityPicker';

import { useActivityFilterLabels } from './useActivityFilterLabels';

/**
 * What the overview is filtered on, one name per applied person, plan unit and activity, in the
 * filters' own wording ("Team Noord · Patiënten", "101 - Jan Jansen", "Activiteit: Wondzorg"). The
 * toolbar's summary shows them and a downloaded file prints them, so both name the filter alike.
 */
export const useAppointmentsFilterNames = (
  selections: PlanningEntitySelection[],
  activityIds: string[]
): string[] => {
  const { t } = useTranslation('common');
  const activityLabels = useActivityFilterLabels(activityIds);

  return [
    ...selections.map((selection) => getSelectionLabel(selection, t)),
    ...activityLabels.map(({ label }) => label)
  ];
};
